import { Button, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutResetCustomerBalances extends Layout {
    buttonProcessLog: Button;
    buttonRunReset: Button;
    labelResetCustomerBalances: Label;
    panelProcessLog: Panel;
    sourceProcessLog: DataSource;
    textboxCustomerIds: Textbox;
    textboxLastProcessed: Textbox;
    textboxUserId: Textbox;
}
